import { Col, Row } from "antd";

function PageHeader({ titulo, subtitulo, extra }) {
  return (
    <Row wrap={false} className="page-header-oisol" align="middle">
      <Col flex="auto">
        <h2>{titulo}</h2>
        {subtitulo ? (
          <span className="page-header-subtitulo">{subtitulo}</span>
        ) : null}
      </Col>
      <Col>{extra}</Col>
    </Row>
  );
}

export default PageHeader;
